import {hostGenerator, scheme} from '@afreecatv/domains';

const NodeEnvType = {
  TEST: 'test',
  DEVELOPMENT: 'development',
  BETA: 'beta',
  STAGING: 'staging',
  STAGING_REAL: 'real',
  PRODUCTION: 'production',
};

const getEnvironment = () => {
  // main 환경
  if (process.env.BUILD_ENV === 'main') {
    return NodeEnvType.PRODUCTION;
  }
  // 개발 환경
  if (process.env.BUILD_ENV === 'develop') {
    return NodeEnvType.PRODUCTION;
  }
  // 스테이징 환경
  if (process.env.BUILD_ENV === 'release') {
    return NodeEnvType.STAGING;
  }
  // 실QA 환경
  if (process.env.BUILD_ENV === 'release-beta') {
    return NodeEnvType.PRODUCTION;
  }

  return NodeEnvType.PRODUCTION;
};
const environment = getEnvironment();

// 앱 스킴 추가
export const globalAPPScheme = scheme.SERVICE_APP_SCHEME; // sooplive://

const globalDomains = hostGenerator({
  environment,
  currentProtocol: 'https:', // document ? document.location.protocol : 'https:',
  hostname: 'sooplive.co.kr',
});
export default globalDomains;
